module.exports = __webpack_public_path__ + "241818b4d51cf9acdf03e04a99b6fc3a.jpg";